import type { VoiceRef } from '../contracts';

export type IssuedQuestion = {
  digest: string;
  lang: string;
  text: string;
  /** Assistant message that emitted the question. */
  messageId: string;
  lines: {
    approving: string;
    rejecting: string;
    executed: string;
    failed: string;
    unknown: string;
  };
};

/** Questions already received from this bound thread's authenticated spoken channel. */
const questions = new Map<string, { value: IssuedQuestion; expires: number }>();
const listeners = new Set<() => void>();
const key = (ref: { kind: string; id: string }) => JSON.stringify([ref.kind, ref.id]);
export function subscribeIssuedQuestions(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
export function rememberIssuedQuestion(ref: { kind: string; id: string }, value: IssuedQuestion) {
  questions.delete(key(ref));
  questions.set(key(ref), { value, expires: Date.now() + 600_000 });
  while (questions.size > 32) questions.delete(questions.keys().next().value!);
  for (const listener of listeners) listener();
}
export function issuedQuestion(ref: VoiceRef): IssuedQuestion | null {
  const found = questions.get(key(ref));
  if (!found || found.expires <= Date.now()) {
    questions.delete(key(ref));
    return null;
  }
  return found.value;
}
export function clearIssuedQuestions() {
  questions.clear();
  for (const listener of listeners) listener();
}
